import {  FacebookLoginProvider,  GoogleLoginProvider,  SocialAuthServiceConfig,  SocialLoginModule,} from '@abacritt/angularx-social-login';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { DefaultUrlSerializer } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialModule } from './material/material-module';
import { RouterModule, Routes } from '@angular/router';
import { QRCodeModule } from 'angularx-qrcode';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './common/login/login.component';
import { MyProfileComponent } from './common/my-profile/my-profile.component';
import { PreloadListDataComponent } from './common/preload-list-data/preload-list-data.component';
import { PreloadListComponent } from './common/preload-list/preload-list.component';
import { SharedataService } from './common/service/sharedata.service';
import { SignupComponent } from './common/signup/signup.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FilterPipe } from './filter.pipe';
import { NcsLibModule } from '@ncs/ncs-lib';
import { AppBoughtComponent } from './app-bought/app-bought.component';
import { AppCollaboratorListComponent } from './app-collaborator-list/app-collaborator-list.component';
import { AppRoleListComponent } from './app-role-list/app-role-list.component';
import { AppRoleUsecaseListComponent } from './app-role-usecase-list/app-role-usecase-list.component';
import { AppStatusComponent } from './app-status/app-status.component';
import { AppStoreComponent } from './app-store/app-store.component';
import { AppUsecaseComponent } from './app-usecase/app-usecase.component';
import { ApplicationApiComponent } from './application-api/application-api.component';
import { ApplicationListComponent } from './application-list/application-list.component';
import { ApplicationUsersComponent } from './application-users/application-users.component';
import { AttributesListComponent } from './attributes-list/attributes-list.component';
import { CommentListComponent } from './comment-list/comment-list.component';
import { HttpInterceptorService } from './common/interceptors/http.service';
import { ScriptLoaderService } from './common/script-loader.service';
import { AddAppRoleUsecaseComponent } from './components/add-app-role-usecase/add-app-role-usecase.component';
import { AppRoleComponent } from './components/add-app-role/add-app-role.component';
import { AddCollaboratorComponent } from './components/add-collaborator/add-collaborator.component';
import { ApiDocsComponent } from './components/api-docs/api-docs.component';
import { CustomApisComponent } from './components/custom-apis/custom-apis.component';
import { DynamicChartComponent } from './components/dynamic-chart/dynamic-chart.component';
import { LocaleMenusComponent } from './components/locale-menus/locale-menus.component';
import { MenuComponent } from './components/menu/menu.component';
import { MultiselectComponent } from './components/multiselect/multiselect.component';
import { NcsAlertComponent } from './components/ncs-alert/ncs-alert.component';
import { NcsChartTableComponent } from './components/ncs-chart-table/ncs-chart-table.component';
import { NcsChartComponent } from './components/ncs-chart/ncs-chart.component';
import { NcsGraphComponent } from './components/ncs-graph/ncs-graph.component';
import { NcsMsgboxComponent } from './components/ncs-msgbox/ncs-msgbox.component';
import { NcsTooltipDirective } from './components/ncs-tooltip/ncs-tooltip.directive';
import { PivotTableComponent } from './components/pivot-table/pivot-table.component';
import { RecursiveMenuComponent } from './components/recursive-menu/recursive-menu.component';
import { SignupInvitationComponent } from './components/signup-invitation/signup-invitation.component';
import { SideMenuComponent } from './components/uiform/side-menu/side-menu.component';
import { UiformBaseComponent } from './components/uiform/uiform-base/uiform-base.component';
import { UiformEditComponent } from './components/uiform/uiform-edit/uiform-edit.component';
import { UiformGraphComponent } from './components/uiform/uiform-graph/uiform-graph.component';
import { UiformListComponent } from './components/uiform/uiform-list/uiform-list.component';
import { UiformPivotComponent } from './components/uiform/uiform-pivot/uiform-pivot.component';
import { UiformViewComponent } from './components/uiform/uiform-view/uiform-view.component';
import { DashboardChartsComponent } from './dashboard-charts/dashboard-charts.component';
import { InvitationDeveloperComponent } from './invitation-developer/invitation-developer.component';
import { ThemeCustomizerComponent } from './layout/theme-customizer/theme-customizer.component';
import { MenuEditorComponent } from './menu-editor/menu-editor.component';
import { OrganizationListComponent } from './organization-list/organization-list.component';
import { OrganizationComponent } from './organization/organization.component';
import { ReportsListComponent } from './reports-list/reports-list.component';
import { RoleListComponent } from './role-list/role-list.component';
import { RulesListComponent } from './rules-list/rules-list.component';
import { TableRowEditorComponent } from './table-row-editor/table-row-editor.component';
import { TasksListComponent } from './tasks-list/tasks-list.component';
import { TeamComponent } from './team/team.component';
import { TruncatePipe } from './truncate.pipe';
import { UiAllformListComponent } from './ui-allform-list/ui-allform-list.component';
import { UiformCreateComponent } from './uiform-create/uiform-create.component';
import { UiformEntryComponent } from './uiform-entry/uiform-entry.component';
import { UiformPreviewComponent } from './uiform-preview/uiform-preview.component';
import { UsecaseBaseComponent } from './usecase/usecase-base/usecase-base.component';
import { UsecaseChartComponent } from './usecase/usecase-chart/usecase-chart.component';
import { UsecaseDataComponent } from './usecase-data/usecase-data.component';
import { UsecasePivotComponent } from './usecase/usecase-pivot/usecase-pivot.component';
import { UserListComponent } from './user-list/user-list.component';
import { UsersComponent } from './users/users.component';
import { CodeEditorComponent } from './code-editor/code-editor.component';
import { RecursiveReportComponent } from './recursive-report/recursive-report.component';
import { DashboardsComponent } from './components/dashboards/dashboards.component';
import { AppInfoComponent } from './components/app-info/app-info.component';
import { ViewReportComponent } from './components/view-report/view-report.component';
import { AppInfoShowComponent } from './components/app-info-show/app-info-show.component';
import { MigrationsListComponent } from './components/migrations-list/migrations-list.component';
import { SchemaDiagramComponent } from './components/schema-diagram/schema-diagram.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { JsonDiffViewerComponent } from './components/json-diff-viewer/json-diff-viewer.component';
import { MenuListComponent } from './menu-list/menu-list.component';
import { SupportTicketComponent } from './support-ticket/support-ticket.component';
import { SupportTicketListComponent } from './support-ticket-list/support-ticket-list.component';
import { ForgotPasswordComponent } from './common/forgot-password/forgot-password.component';
import { AddAppRoleAccessComponent } from './components/add-app-role-access/add-app-role-access.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { DatePipe } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ChildFormDataListComponent } from './child-form-data-list/child-form-data-list.component';
import { ComboboxComponent } from './combobox/combobox.component';
import { UsecaseDatabaseComponent } from './usecase-database/usecase-database.component';
import { DahodDashboardComponent } from './components/dahod-dashboard/dahod-dashboard.component';
import { NgxEditorModule } from 'ngx-editor';
import { PublicFormComponentComponent } from './public-form-component/public-form-component.component';
import { ApplicationInfoComponent } from './application-info/application-info.component';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { FakeLocaleInterceptor } from './interceptors/fake-locale.interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { ApplicationConfigurationComponent } from './application-configuration/application-configuration.component';
import { EmailConfigurationComponent } from './email-configuration/email-configuration.component';
import { EmailTemplateComponent } from './email-template/email-template.component';
import { JasperComponent } from './components/uiform/jasper/jasper.component';
import { TestEmailComponent } from './test-email/test-email.component';
import { AiReportComponent } from './components/uiform/ai-report/ai-report.component';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReactiveFormsModule } from '@angular/forms';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ApplicationAccessComponent } from './application-access/application-access.component';
import {  NgxMatDatetimePickerModule, NgxMatNativeDateModule,NgxMatTimepickerModule,} from '@angular-material-components/datetime-picker';
import { TaskBoardComponent } from './components/uiform/task-board/task-board.component';
import { TaskEditModalComponent } from './components/uiform/task-board/task-edit-modal/task-edit-modal.component';
import { TaskSearchFilterComponent } from './components/uiform/task-board/task-search-filter/task-search-filter.component';
import { PaymentGatewayConfigComponent } from './payment-gateway-config/payment-gateway-config.component';
import { TestPaymentGatewayComponent } from './test-payment-gateway/test-payment-gateway.component';
import { UploadLogsComponent } from './upload-logs/upload-logs.component';
import { AssetReportComponent } from './asset-report/asset-report.component';
const routes: Routes = [];
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    SignupComponent,
    MyProfileComponent,
    PreloadListComponent,
    PreloadListDataComponent,
    FilterPipe,
    OrganizationListComponent,
    ApplicationListComponent,
    UserListComponent,
    CommentListComponent,
    RoleListComponent,
    AppUsecaseComponent,
    UsecaseDataComponent,
    AttributesListComponent,
    AppStoreComponent,
    AppStatusComponent,
    AppBoughtComponent,
    OrganizationComponent,
    UsersComponent,
    UiformCreateComponent,
    AppRoleListComponent,
    AppRoleUsecaseListComponent,
    AppCollaboratorListComponent,
    TableRowEditorComponent,
    AddCollaboratorComponent,
    AppRoleComponent,
    AddAppRoleUsecaseComponent,
    ApplicationApiComponent,
    ApplicationUsersComponent,
    RulesListComponent,
    NcsTooltipDirective,
    NcsAlertComponent,
    NcsChartComponent,
    UsecaseChartComponent,
    ThemeCustomizerComponent,
    UiformEntryComponent,
    UiformViewComponent,
    UiformEditComponent,
    UiformListComponent,
    SideMenuComponent,
    UiformGraphComponent,
    MenuEditorComponent,
    RecursiveMenuComponent,
    MenuComponent,
    LocaleMenusComponent,
    CustomApisComponent,
    ApiDocsComponent,
    DynamicChartComponent,
    PivotTableComponent,
    NcsChartTableComponent,
    TruncatePipe,
    DashboardChartsComponent,
    UiformPreviewComponent,
    UiformPivotComponent,
    MultiselectComponent,
    UiAllformListComponent,
    NcsMsgboxComponent,
    NcsGraphComponent,
    TasksListComponent,
    InvitationDeveloperComponent,
    SignupInvitationComponent,
    UsecasePivotComponent,
    UsecaseBaseComponent,
    UiformBaseComponent,
    TeamComponent,
    ReportsListComponent,
    CodeEditorComponent,
    RecursiveReportComponent,
    DashboardsComponent,
    AppInfoComponent,
    ViewReportComponent,
    AppInfoShowComponent,
    MigrationsListComponent,
    SchemaDiagramComponent,
    JsonDiffViewerComponent,
    MenuListComponent,
    SupportTicketComponent,
    SupportTicketListComponent,
    ForgotPasswordComponent,
    AddAppRoleAccessComponent,
    MenuItemComponent,
    ChildFormDataListComponent,
    ComboboxComponent,
    UsecaseDatabaseComponent,
    DahodDashboardComponent,
    PublicFormComponentComponent,
    ApplicationInfoComponent,
    ApplicationConfigurationComponent,
    EmailConfigurationComponent,
    EmailTemplateComponent,
    JasperComponent,
    TestEmailComponent,
    AssetReportComponent,
    PaymentGatewayConfigComponent,
    TestPaymentGatewayComponent,
    AiReportComponent,
    TaskBoardComponent,
    ApplicationAccessComponent,
    UploadLogsComponent,
  ],
  imports: [
    TaskSearchFilterComponent,
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    SocialLoginModule,
    QRCodeModule,
    NcsLibModule,
    NgxJsonViewerModule,
    ImageCropperModule,
    DragDropModule,
    NgxEditorModule,
    NgxBarcode6Module,
    NgSelectModule,
    MatDatepickerModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxMatMomentModule,
    MatSelectModule,
    MatFormFieldModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    CdkStepperModule,
    ScrollingModule,   
    MatIconModule,
    RouterModule.forRoot(routes, { useHash: true }),
    NgxDaterangepickerMd.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    CdkStepperModule,
  ],
  providers: [
    CookieService,
    SharedataService,
    ScriptLoaderService,
    DefaultUrlSerializer,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FakeLocaleInterceptor,
      multi: true,
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '661073083193-qsje9g145n5dcacl8shr7a7oamklcp59.apps.googleusercontent.com'
            ),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(
              '1063592711109689',
              'fbLoginOptions'
            ),
          },
        ],
        onError: (err) => {
          console.error(err);
        },
      } as SocialAuthServiceConfig,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        subscriptSizing: 'dynamic',
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }